
export interface Contact {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

// Demo contacts data
export const demoContacts: Contact[] = [
  { id: '1', name: 'Alex Johnson', email: 'alex@example.com' },
  { id: '2', name: 'Sam Smith', email: 'sam@example.com' },
  { id: '3', name: 'Taylor Brown', email: 'taylor@example.com' },
  { id: '4', name: 'Jordan Wilson', email: 'jordan@example.com' },
  { id: '5', name: 'Casey Miller', email: 'casey@example.com' },
  { id: '6', name: 'Morgan Lee', email: 'morgan@example.com' },
  { id: '7', name: 'Riley Thomas', email: 'riley@example.com' },
  { id: '8', name: 'Quinn Adams', email: 'quinn@example.com' },
  { id: '9', name: 'Jamie Garcia', email: 'jamie@example.com' },
  { id: '10', name: 'Drew Martin', email: 'drew@example.com' },
];
